/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axis_label_click_event_1 = require("./axis-label-click-event");
var drag_event_1 = require("./drag-event");
var drag_end_event_1 = require("./drag-end-event");
var drag_start_event_1 = require("./drag-start-event");
var legend_item_hover_event_1 = require("./legend-item-hover-event");
var legend_item_leave_event_1 = require("./legend-item-leave-event");
var note_click_event_1 = require("./note-click-event");
var note_hover_event_1 = require("./note-hover-event");
var note_leave_event_1 = require("./note-leave-event");
var pane_render_event_1 = require("./pane-render-event");
var plot_area_click_event_1 = require("./plot-area-click-event");
var plot_area_hover_event_1 = require("./plot-area-hover-event");
var plot_area_leave_event_1 = require("./plot-area-leave-event");
var render_event_1 = require("./render-event");
var select_event_1 = require("./select-event");
var select_end_event_1 = require("./select-end-event");
var select_start_event_1 = require("./select-start-event");
var series_click_event_1 = require("./series-click-event");
var series_hover_event_1 = require("./series-hover-event");
var series_over_event_1 = require("./series-over-event");
var series_leave_event_1 = require("./series-leave-event");
var zoom_event_1 = require("./zoom-event");
var zoom_end_event_1 = require("./zoom-end-event");
var zoom_start_event_1 = require("./zoom-start-event");
var EVENT_MAP = {
    axisLabelClick: axis_label_click_event_1.AxisLabelClickEvent,
    drag: drag_event_1.DragEvent,
    dragEnd: drag_end_event_1.DragEndEvent,
    dragStart: drag_start_event_1.DragStartEvent,
    legendItemHover: legend_item_hover_event_1.LegendItemHoverEvent,
    legendItemLeave: legend_item_leave_event_1.LegendItemLeaveEvent,
    noteClick: note_click_event_1.NoteClickEvent,
    noteHover: note_hover_event_1.NoteHoverEvent,
    noteLeave: note_leave_event_1.NoteLeaveEvent,
    paneRender: pane_render_event_1.PaneRenderEvent,
    plotAreaClick: plot_area_click_event_1.PlotAreaClickEvent,
    plotAreaHover: plot_area_hover_event_1.PlotAreaHoverEvent,
    plotAreaLeave: plot_area_leave_event_1.PlotAreaLeaveEvent,
    render: render_event_1.RenderEvent,
    select: select_event_1.SelectEvent,
    selectEnd: select_end_event_1.SelectEndEvent,
    selectStart: select_start_event_1.SelectStartEvent,
    seriesClick: series_click_event_1.SeriesClickEvent,
    seriesHover: series_hover_event_1.SeriesHoverEvent,
    seriesOver: series_over_event_1.SeriesOverEvent,
    seriesLeave: series_leave_event_1.SeriesLeaveEvent,
    zoom: zoom_event_1.ZoomEvent,
    zoomEnd: zoom_end_event_1.ZoomEndEvent,
    zoomStart: zoom_start_event_1.ZoomStartEvent
};
/**
 * @hidden
 */
var InstanceEventService = /** @class */ (function () {
    function InstanceEventService() {
    }
    InstanceEventService.prototype.create = function (name, args, sender) {
        if (EVENT_MAP[name]) {
            return new EVENT_MAP[name](args, sender);
        }
    };
    return InstanceEventService;
}());
exports.InstanceEventService = InstanceEventService;
